import { useState } from "react";
import { SubdistrictData, useSubdistricts } from "@/api/subdistrict";
import { FieldInput } from "@/components/form/field-input";
import { FieldCombobox } from "@/components/form/field-combobox";
import { useFormContext } from "react-hook-form";

interface VillageFormFieldsProps {
  isDisabled?: boolean;
  defaultSubdistrict?: SubdistrictData;
}

export function VillageFormFields({
  isDisabled = false,
  defaultSubdistrict,
}: VillageFormFieldsProps) {
  const [subdistrictSearch, setSubdistrictSearch] = useState("");
  const { data: subdistricts } = useSubdistricts({
    subdistrictName: subdistrictSearch,
  });

  const form = useFormContext();
  const subdistrict = form.watch("subdistrict") as SubdistrictData;

  const currentSubdistrict = subdistrict || defaultSubdistrict;
  const subdistrictsWithoutCurrentSubdistrict = currentSubdistrict
    ? subdistricts?.content?.filter(
        (subdistrict) => subdistrict.id !== currentSubdistrict?.id,
      )
    : subdistricts?.content;
  const requiredOptions = currentSubdistrict ? [currentSubdistrict] : [];

  // Get all subdistricts for duplicate name checking
  const allSubdistricts = requiredOptions.concat(
    subdistrictsWithoutCurrentSubdistrict ?? [],
  );

  return (
    <>
      <FieldInput
        name="villageName"
        label="Sub District Name"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldCombobox
        name="subdistrict"
        label="District Name"
        search={subdistrictSearch}
        setSearch={setSubdistrictSearch}
        isDisabled={isDisabled}
        options={allSubdistricts?.map((subdistrict) => {
          // For other options, apply duplicate logic
          return {
            value: subdistrict,
            label: `${subdistrict.subdistrictName} [${subdistrict.city.cityName}]`,
          };
        })}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="postalCode"
        label="Postal Code"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
      />
      <FieldInput
        name="villageCode"
        label="Sub District Code"
        isDisabled={isDisabled}
        hasRequiredAsterisk={false}
      />
    </>
  );
}
